var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4514 15.9169C24.4514 15.9003 24.4348 15.8836 24.4348 15.8669C24.4348 15.8503 24.4181 15.8169 24.4014 15.8003C24.3848 15.7836 24.3681 15.7669 24.3681 15.7503L24.3181 15.7003C24.3014 15.6836 24.2848 15.6669 24.2514 15.6669L24.2181 15.6336L8.11809 8.38359C7.96809 8.31692 7.78476 8.35025 7.66809 8.46692C7.55143 8.58359 7.51809 8.76692 7.58476 8.91692L10.7348 16.0003L7.58476 23.0836C7.51809 23.2336 7.55143 23.4169 7.66809 23.5336C7.75143 23.6169 7.85143 23.6503 7.95143 23.6503C8.00143 23.6503 8.06809 23.6336 8.11809 23.6169L24.2181 16.3669C24.2348 16.3669 24.2514 16.3503 24.2514 16.3336C24.2681 16.3169 24.2848 16.3169 24.3181 16.3003L24.3681 16.2503C24.3848 16.2336 24.4014 16.2169 24.4014 16.2003C24.4181 16.1836 24.4181 16.1503 24.4348 16.1336C24.4348 16.1169 24.4514 16.1003 24.4514 16.0836V15.9169ZM8.75143 22.4503L11.4348 16.4003H22.1681L8.75143 22.4503ZM11.4348 15.6003L8.75143 9.55025L22.1848 15.6003H11.4348Z",
    fill: "#FBFAFE",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.5d4e6795e77a3b98e8d46f50fdf1d3c7.svg";
export { ForwardRef as ReactComponent };